import { $window } from '../utils/globals';

$window.on('load resize', () => {
	if ($window.width() > 767) {
		return
	}
	
	const $container = $('.js-hero-animation');
	const $target = $container.find('.hero__animation-holder');

	const percent = $window.width() > 373 ? 0.25 : 0.23;
	const height = $target.outerHeight() - $target.outerHeight() * percent;

	$target.css({
		'margin-bottom': `-${height}px`,
	});
});
